export default __webpack_public_path__ + "static/card3-2e857e8dba8374af5606369eb9cdc020.png";